import { call, all, put, takeLatest } from 'redux-saga/effects';
import CenterDCBReportActionTypes from './center-DCB-report.types';
import {
	fetchCenterDCBReportFailure,
	fetchCenterDCBReportSuccess,
	fetchCenterDCBReportResponseChanged,
} from './center-DCB-report.action';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import { centerDCBReportListGet } from './center-DCB-report.service';

/** *********************  START GET CENTER DCB REPORT DETAILS  ******************** */
export function* getCenterDCBReportList({ payload }: any) {
	try {
		const key = 'CenterDCBReportListKey';
		const { companyID, databaseName, fromDate, toDate, branchID, centerID, funderID } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			FromDate: fromDate,
			ToDate: toDate,
			BranchID: branchID,
			CenterID: centerID,
			FunderID: funderID,
			CompanyID: companyID,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(centerDCBReportListGet, encodeData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchCenterDCBReportFailure(responseData.data));
		} else {
			yield put(fetchCenterDCBReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchCenterDCBReportFailure(error));
	}
}

export function* resetCenterDCBReportListResponse() {
	yield put(fetchCenterDCBReportResponseChanged());
}

export function* onGetCenterDCBReportListDetails() {
	yield takeLatest(
		CenterDCBReportActionTypes.FETCH_CENTER_DCB_REPORT_START,
		getCenterDCBReportList,
	);
}

export function* centerDCBReportListResponseReset() {
	yield takeLatest(
		CenterDCBReportActionTypes.FETCH_CENTER_DCB_REPORT_RESPONSE_CHANGED,
		resetCenterDCBReportListResponse,
	);
}
/** *********************  END GET CENTER DCB REPORT DETAILS  ******************** */

export function* centerDCBReportSaga() {
	yield all([call(onGetCenterDCBReportListDetails), call(centerDCBReportListResponseReset)]);
}
